import { connectHits } from 'react-instantsearch-dom'

export const RelatedTopicsList = (params) => {
  const { hits, topicId, widgetTitle, totalItemCount } = params
  const hitsWithoutCurrent = hits.filter((hit) => hit.id !== parseInt(topicId)).slice(0, totalItemCount)

  if (!hitsWithoutCurrent.length) return null

  return (
    <div>
      { widgetTitle ? <h3 className='related-topics__widget-title'>{widgetTitle}</h3> : '' }
      <ul>
        {
          hitsWithoutCurrent.map((hit, idx) => {
            let iconClass = hit.has_answer ? 'icon--checkmark qa-icon-answered' : hit.content_type === 'question' ? 'icon--question qa-icon-question' : ''

            return <li className='related-topics__topic'>
              <h6 className='related-topics__topic-title'>
                <a className='link link--topic' href={hit.topic_url}>{hit.title}</a>
                {iconClass ? <span className={'icon icon--replace icon--round ' + iconClass}>icon</span> : ''}
              </h6>
              <a href={`/fid-${hit.forum}`} className='text--meta'>{ hit.forum_title }</a>
            </li>
          })
        }
      </ul>
    </div>
  )
}

const RelatedTopicsListContainer = connectHits(RelatedTopicsList)

export default RelatedTopicsListContainer
